import { render, staticRenderFns } from "./ContactoRegistra.vue?vue&type=template&id=1da9c456&"
import script from "./ContactoRegistra.vue?vue&type=script&lang=js&"
export * from "./ContactoRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports